declare global {
  interface Window {
    UpdateSessionVariables: (startDate: string | Date) => void;
  }
}

export const updateSessionVariables = (startDate: string | Date) => {
  window.UpdateSessionVariables(startDate);
};
